import React from "react";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import PersonIcon from "@material-ui/icons/Person";
import MemoryIcon from "@material-ui/icons/Memory";
import { formatDurationExact } from "pages/labelerVideo/utils/formatTime";
import { analyseTheme } from "../../../analyseTheme";
import IncidentsChartLegend from "./IncidentsChartLegend";

type Props = {
  mediaName: string;
  durationExactSec: number;
  labelRowCount: number;
  selectedModelCount: number;
  modelLabel?: string | null;
  secondaryModelLabel?: string | null;
  isLoadingVideos?: boolean;
};

const formatLabelRowCount = (count: number) =>
  `${count} label${count > 1 ? "s" : ""}`;

const formatSelectedModelCount = (count: number) =>
  `${count} modèle${count > 1 ? "s" : ""}`;

const metaIconStyle: React.CSSProperties = {
  fontSize: 16,
  color: analyseTheme.textSecondary,
  flexShrink: 0,
};

const MetaItem = ({
  icon,
  children,
}: {
  icon: React.ReactNode;
  children: React.ReactNode;
}) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: "4px",
    }}
  >
    {icon}
    {children}
  </span>
);

const IncidentsChartHeader = ({
  mediaName,
  durationExactSec,
  labelRowCount,
  selectedModelCount,
  modelLabel,
  secondaryModelLabel = null,
  isLoadingVideos = false,
}: Props) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: "12px",
      marginBottom: 8,
      marginTop: 16,
    }}
  >
    <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
      <div>
        <Typography
          variant="h6"
          style={{
            fontWeight: 600,
            color: analyseTheme.textPrimary,
            borderLeft: `3px solid ${analyseTheme.secondaryLight}`,
            paddingLeft: 8,
            marginBottom: 4,
          }}
        >
          {mediaName}
        </Typography>
        <Typography
          variant="body1"
          component="div"
          style={{
            color: analyseTheme.textSecondary,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "4px 10px",
          }}
        >
          <MetaItem icon={<AccessTimeIcon style={metaIconStyle} />}>
            {formatDurationExact(durationExactSec)}
          </MetaItem>
          <span aria-hidden="true">·</span>
          <MetaItem icon={<PersonIcon style={metaIconStyle} />}>
            {formatLabelRowCount(labelRowCount)}
          </MetaItem>
          <span aria-hidden="true">·</span>
          <MetaItem icon={<MemoryIcon style={metaIconStyle} />}>
            {formatSelectedModelCount(selectedModelCount)}
          </MetaItem>
        </Typography>
      </div>
      {isLoadingVideos && (
        <CircularProgress
          size={18}
          style={{ color: analyseTheme.textSecondary, flexShrink: 0 }}
        />
      )}
    </div>

    <IncidentsChartLegend
      modelLabel={modelLabel}
      secondaryModelLabel={secondaryModelLabel}
    />
  </div>
);

export default IncidentsChartHeader;
